import { render, staticRenderFns } from "./TesterForm.vue?vue&type=template&id=6d36ca64&scoped=true"
import script from "./TesterForm.vue?vue&type=script&lang=js"
export * from "./TesterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36ca64",
  null
  
)

export default component.exports